/** @jsx jsx */
import { CheckmarkCircle } from '@datacamp/waffles/icon';
import { Paragraph } from '@datacamp/waffles/paragraph';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';

type Props = Record<string, unknown>;

const ThanksForRating: React.FC<Props> = () => {
  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
      }}
    >
      <CheckmarkCircle className="dc-u-mr-4" />
      <Paragraph
        className="dc-u-m-4"
        css={{ fontWeight: tokens.fontWeights.bold }}
      >
        Thanks for your feedback!
      </Paragraph>
    </div>
  );
};

export default ThanksForRating;
